module.exports = __webpack_public_path__ + "media/images/icon_blog01_on_19-17-94798ad38703bcf39f53836e4a66af85.png";